export default {
  // 判断报警类型 web
  getAlarmType (atype) {
    if (atype === 'nb-co-test') {
      return 'NB一氧化碳测试'
    } else if (atype === 'nb-co') {
      return 'NB一氧化碳报警'
    } else if (atype === 'F-Test') {
      return '烟感自检报警'
    } else if (atype === 'F-Fire') {
      return '烟感火警'
    } else if (atype === 'F-LB') {
      return '烟感低电压报警'
    } else if (atype === 'F-Sensor') {
      return '烟感传感器报警'
    } else if (atype === 'F-Maze') {
      return '烟感迷宫脏'
    } else if (atype === 'C-LB') {
      return '底座低电压报警'
    } else if (atype === 'C-link') {
      return '底座与烟感连接异常报警'
    } else if (atype === 'C-AT') {
      return '底座防拆报警'
    } else if (atype === 'sub_fire') {
      return '烟感'
    } else if (atype === 'sub_co') {
      return '一氧化碳'
    } else if (atype === 'sub_gas') {
      return '燃气'
    } else if (atype === 'sub_keysos') {
      return ' 按钮报警（紧急报警）'
    } else if (atype === 'sub_infrared') {
      return '红外防盗'
    } else if (atype === 'sub_water') {
      return '水浸'
    } else if (atype === 'sos') {
      return '一键报警'
    } else if (atype === 'sub_lowvoltage') {
      return '子机低电量'
    } else if (atype === 'sub_test') {
      return '烟感测试'
    } else if (atype === 'sub_lowhumidity') {
      return '湿度低'
    } else if (atype === 'sub_highhumidity') {
      return '湿度高'
    } else if (atype === 'sub_lowtemp') {
      return '温度低'
    } else if (atype === 'sub_hightemp') {
      return '温度高'
    } else if (atype === 'sub_lowlevel') {
      return '水位低'
    } else if (atype === 'sub_highlevel') {
      return '水位高'
    } else if (atype === 'sub_lowpressure') {
      return '水压低'
    } else if (atype === 'sub_highpressure') {
      return '水压高'
    } else if (atype === 'sub_closedoor') {
      return '已关门'
    } else if (atype === 'sub_opendoor') {
      return '已开门'
    } else if (atype === 'dooropen') {
      return '已开门'
    } else if (atype === 'doorclose') {
      return '已关门'
    } else if (atype === 'c-at') {
      return '已拆开'
    } else if (atype === 'sub_fire_test') {
      return '子机烟感测试'
    } else if (atype === 'f-fire') {
      return '烟雾报警'
    } else if (atype === 'f-lb') {
      return '低电量报警'
    } else if (atype === 'F-Heart') {
      return '心跳/恢复正常'
    } else if (atype === 'C-At') {
      return '拆除'
    } else if (atype === 'f-test') {
      return '测试'
    } else if (atype === 'f-sensor') {
      return '故障'
    } else if (atype === 'F-Temp') {
      return '温度报警'
    } else if (atype === 'sos_test') {
      return '测试一键报警测试'
    } else if (atype === 'sys_isactivity') {
      return '活动监测警报'
    } else if (atype === 'poweroff') {
      return '关机'
    } else if (atype === 'poweron') {
      return '开机'
    } else if (atype === 'lowbattery') {
      return '低电量报警'
    } else {
      return atype
    }
  },
  // 主设备类型
  getDeviceType (dtype) {
    let type = parseInt(dtype)
    if (type === 700) {
      return '智能网关'
    } else if (type === 701) {
      return '智能网关'
    } else if (type === 300) {
      return 'NB烟感'
    } else if (type === 99) {
      return 'NB烟感'
    } else if (type === 200) {
      return '一键报警'
    } else if (type === 400) {
      return '门锁'
    } else if (type === 501) {
      return '一氧化碳'
    } else if (type === 502) {
      return '燃气'
    } else if (type === 800) {
      return '一键报警网关'
    } else if (type === 503) {
      return '灭火器压力表'
    } else {
      return '测试'
    }
  },
  GetDateStr (AddDayCount, time) {
    let dd = new Date(time)
    dd.setDate(dd.getDate() + AddDayCount)// 获取AddDayCount天后的日期 负数为前N天 正数为后N天
    let date = dd.Format('yyyy-MM-dd')
    return date
  }
}



// WEBPACK FOOTER //
// ./src/common/common.js